import { Fragment } from 'react';
import { Visible } from 'react-grid-system';
import r from 'render-dom';
import styled from 'styled-components';

import ProductsSectionSkeleton from 'components/App/Dashboard/ProductsSection/SkeletonLayout';
import GridSkeleton from 'components/App/Dashboard/Body/DashboardGrid/SkeletonLayout';

const Container = styled.div`
    display: flex;
    margin-left: 110px;
    position: absolute;
    width: calc(100vw - 110px);
`;

const Content = styled.div`
    flex: 1;
`;

const Sidebar = styled.div`
    height: 100vh;
    overflow: hidden;
    position: relative;
    width: 100%;
`;

const SidebarContainer = styled.div`
    box-sizing: border-box;
    width: 340px;
`;

const SidebarInner = styled.div`
    bottom: 0px;
    left: 0px;
    margin-bottom: 0px;
    margin-right: 0px;
    overflow: hidden;
    padding: 0 15px;
    position: absolute;
    right: 0px;
    top: 0px;
`;

const WidgetGridContainer = styled.div`
    min-height: 100vh;
    overflow: hidden;
    position: relative;
    width: 100%;
`;

export default function WidgetGridSkeleton() {
    return (
        r(Fragment, [
            r(Visible, { lg: true, xl: true }, [
                r(Container, [
                    r(SidebarContainer, [
                        r(Sidebar, [
                            r(SidebarInner, [
                                r(ProductsSectionSkeleton, { showHeaderSkeleton: true }),
                            ]),
                        ]),
                    ]),
                    r(Content, [
                        r(WidgetGridContainer, [
                            r(GridSkeleton),
                        ]),
                    ]),
                ])
            ]),
        ])
    );
}

WidgetGridSkeleton.propTypes = {};
